module.exports = __webpack_public_path__ + "img/monri-logo.b6d2e262.png";